module.exports = __webpack_public_path__ + "static/media/users.a50a53a9.svg";